import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import HeroSection from "./sections/HeroSection";
import MarqueeSection from "./sections/MarqueeSection";
import GuidanceSection from "./sections/GuidanceSection";
import ServicesSection from "./sections/ServicesSection";
import RemediesSection from "./sections/RemediesSection";
import DownloadAppSection from "./sections/DownloadAppSection";
import FaqSection from "./sections/FaqSection";

function UserHomeFront() {
  const location = useLocation();

  useEffect(() => {
    const isFaq = location.pathname === "/faq" || location.hash === "#faq";
    const isDownload =
      location.pathname === "/download-app" ||
      location.hash === "#download-app" ||
      location.hash === "#download";

    const sectionId = isFaq ? "faq" : isDownload ? "download-app" : null;
    if (!sectionId) return;

    const timer = setTimeout(() => {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
    }, 150);

    return () => clearTimeout(timer);
  }, [location.pathname, location.hash]);

  return (
    <>
      <HeroSection />
      <MarqueeSection />
      <GuidanceSection />
      <ServicesSection />
      <RemediesSection />
      <DownloadAppSection />
      <FaqSection />
    </>
  );
}

export default UserHomeFront;
